<template>
  <div class="travel-review-page">
    <!-- 顶部导航栏 -->
    <el-header class="page-header">
      <!-- <el-button
        icon="el-icon-arrow-left"
        class="back-btn"
        @click="handleBack"
      ></el-button> -->
      <div class="back-btn" @click="handleBack">
        <i class="el-icon-arrow-left"></i>
      </div>
      <h1 class="page-title">{{ $t("orderEvaluation") }}</h1>
    </el-header>
    <main class="main-content">
      <!-- 订单信息卡片 -->
      <el-card class="order-info-card">
        <div class="order-header">
          <h2 class="order-title">{{ orderInfo.productName }}</h2>
          <span class="order-status">{{ $t("completed") }}</span>
        </div>
        <div class="order-details">
          <div class="detail-item">
            <span class="detail-label">{{ $t("orderNo") }}：</span>
            <span class="detail-value">{{ orderInfo.orderNumber }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{ $t("travelDate") }}：</span>
            <span class="detail-value">{{ orderInfo.travelDate }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{ $t("traveler") }}：</span>
            <span class="detail-value">{{ orderInfo.travelers }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{ $t("orderAmount") }}：</span>
            <span class="detail-value"
              >¥{{
                orderInfo && orderInfo.amount
                  ? orderInfo.amount.toFixed(2)
                  : "--"
              }}</span
            >
          </div>
        </div>
      </el-card>
      <!-- 评价表单 -->
      <el-card class="review-form-card">
        <h2 class="form-title">{{ $t("shareYourExperience") }}</h2>
        <el-form
          ref="reviewForm"
          :model="reviewForm"
          :rules="rules"
          class="review-form"
          label-width="120px"
        >
          <!-- 星级评分 -->
          <el-form-item
            :label="$t('overallRating')"
            prop="rating"
            class="form-item"
          >
            <el-rate
              v-model="reviewForm.rating"
              :max="5"
              :colors="['#999999', '#999999', '#FF9900', '#FF9900', '#FF9900']"
              class="rating-component"
              @change="handleRatingChange"
            ></el-rate>
            <span class="rating-text">{{ ratingText }}</span>
          </el-form-item>
          <!-- 评价内容 -->
          <el-form-item
            :label="$t('reviewContent')"
            prop="content"
            class="form-item"
          >
            <el-input
              type="textarea"
              v-model="reviewForm.content"
              :rows="5"
              :placeholder="$t('pleaseShareTravelExperience')"
              class="review-textarea"
              @input="handleContentInput"
            ></el-input>
            <div class="word-count">
              <span>{{ contentLength }}/500</span>
            </div>
          </el-form-item>
          <!-- 图片上传 -->
          <el-form-item :label="$t('uploadImages')" class="form-item">
            <el-upload
              class="image-uploader"
              action="#"
              :auto-upload="false"
              :on-change="(file, fileList) => handleFileSelect(file, fileList)"
              :file-list="fileList"
              list-type="picture-card"
              :limit="5"
              :on-exceed="handleExceed"
              multiple
            >
              <i slot="default" class="el-icon-plus"></i>
              <div slot="file" slot-scope="{ file }">
                <img
                  class="el-upload-list__item-thumbnail"
                  :src="file.url"
                  alt="uploaded image"
                />
                <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview(file)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file)"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="preview" />
            </el-dialog>
            <p class="upload-tip">{{ $t("uploadImageTip") }}</p>
          </el-form-item>
          <!-- 提交按钮 -->
          <el-form-item class="submit-btn-container">
            <el-button
              type="primary"
              class="submit-btn"
              @click="handleSubmit"
              :loading="submitting"
            >
              {{ $t("submitReview") }}
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </main>
    <!-- 提交成功提示 -->
    <el-dialog
      :title="$t('tip')"
      :visible.sync="successDialogVisible"
      :show-close="false"
      width="300px"
    >
      <div class="success-message">
        <i class="el-icon-success success-icon"></i>
        <p>{{ $t("reviewSubmittedSuccessfully") }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="
            successDialogVisible = false;
            handleBack();
          "
          >{{ $t("confirm") }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "TravelReview",
  data() {
    return {
      orderNo: null,
      // 订单信息
      orderInfo: {},
      // 评价表单数据
      reviewForm: {
        rating: 0,
        content: "",
      },
      // 图片上传相关
      isUploading: false,
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: "",
      // 提交状态
      submitting: false,
      // 成功提示对话框
      successDialogVisible: false,
    };
  },
  computed: {
    // 评分对应的文本
    ratingText() {
      const texts = [
        "",
        this.$t("veryPoor"),
        this.$t("average"),
        this.$t("good"),
        this.$t("veryGood"),
        this.$t("excellent"),
      ];
      return this.reviewForm.rating ? texts[this.reviewForm.rating] : "";
    },
    // 评价内容长度
    contentLength() {
      return this.reviewForm.content.length;
    },
    // 表单验证规则（国际化，切换语言实时生效）
    rules() {
      return {
        rating: [
          {
            required: true,
            message: this.$t("pleaseGiveRating"),
            trigger: "change",
          },
        ],
        content: [
          {
            required: true,
            message: this.$t("pleaseEnterReviewContent"),
            trigger: "blur",
          },
          {
            max: 500,
            message: this.$t("reviewContentMaxLength"),
            trigger: "blur",
          },
        ],
      };
    },
  },
  created() {
    this.orderNo = this.$route.query.orderNo;
    this.getOrderInfo();
  },
  methods: {
    async getOrderInfo() {
      try {
        this.$get("/order/info", { order_no: this.orderNo }).then((res) => {
          if (res.data.code === 1) {
            this.orderInfo = res.data.data;
            console.log(this.orderInfo);
          }
        });
      } catch (err) {
        this.errorMessage = this.$t("networkErrorOrderInfoFailed");
      }
    },
    // 返回上一页
    handleBack() {
      // 实际项目中这里应该使用路由返回
      window.history.back();
    },
    // 处理评分变化
    handleRatingChange(value) {
      if (value <= 2) {
        this.$message.warning(this.$t("ratingLowContactService"));
      }
    },
    // 处理评价内容输入
    handleContentInput() {
      // 可以在这里添加实时处理逻辑
      if (this.contentLength > 500) {
        this.reviewForm.content = this.reviewForm.content.substring(0, 500);
        this.$message.warning(this.$t("reviewContentMaxLength"));
      }
    },
    // 处理图片上传变化
    handleFileSelect(file, fileList) {
      this.fileList = fileList;
      // 为本地图片生成预览URL
      if (!file.url && file.raw) {
        file.url = URL.createObjectURL(file.raw);
      }
    },
    // 处理图片超出数量限制
    handleExceed(files, fileList) {
      this.$message.warning(
        `${this.$t("maxUpload5Images")}，${this.$t("canStillUpload")}${
          5 - fileList.length
        }${this.$t("images")}`,
      );
    },
    // 处理图片预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 处理图片删除
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      if (index !== -1) {
        this.fileList.splice(index, 1);
      }
      // 释放URL对象
      if (file.url && file.raw) {
        URL.revokeObjectURL(file.url);
      }
    },
    // 提交表单
    async handleSubmit() {
      // 检查是否正在上传
      if (this.isUploading) {
        this.$message.warning(this.$t("uploadingPleaseWait"));
        return;
      }
      this.$refs.reviewForm.validate(async (valid) => {
        if (valid) {
          // const filesToUpload = this.fileList;
          const filesToUpload = this.fileList.filter((file) => {
            // 条件：serverUrl 不存在 / 为空字符串 / 为 undefined（三种常见“未上传”场景）
            return !file.serverUrl || file.serverUrl.trim() === "";
          });
          if (filesToUpload.length > 0) {
            // 显示上传中提示
            this.isUploading = true;
            const loading = this.$loading({
              lock: true,
              text: this.$t("uploadingFile"),
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            });
            try {
              await this.uploadFiles(filesToUpload);
              this.submitForm();
            } catch (error) {
              console.error("文件上传失败:", error);
            } finally {
              this.isUploading = false;
              loading.close();
            }
          } else {
            this.submitForm();
          }
        } else {
          return false;
        }
      });
    },
    /**
     * 上传多个文件到服务器（仅处理新图，已在调用前筛选）
     * @param {Array<File>} files - 需要上传的新图（含 raw 文件对象）
     * @returns {Promise} - 上传结果的Promise
     */
    uploadFiles(files) {
      return new Promise((resolve, reject) => {
        if (files.length === 0) {
          return;
        }
        const formData = new FormData();
        files.forEach((file) => {
          formData.append(`files[]`, file.raw);
        });
        this.$post("/review/review_file_upload", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
          .then((res) => {
            if (res.data.code === 1) {
              this.images = res.data.data;
              const formattedFiles = res.data.data.map((url, index) => {
                // 找到原始文件信息用于保留名称和uid
                const originalFile = files[index] || {};
                return {
                  uid: originalFile.uid || Date.now() + index, // 保留原始uid或生成新的
                  name: originalFile.name || `upload-${index + 1}.jpg`, // 保留文件名
                  url: url, // 服务器返回的图片URL（用于预览）
                  serverUrl: url, // 用于最终提交的URL
                  status: "success", // 标记为上传成功状态
                };
              });
              // 更新文件列表为格式化后的对象数组
              this.fileList = formattedFiles;
              resolve(res.data);
            } else {
              this.$message.error(res.data.msg || this.$t("uploadFailed"));
              reject(new Error(res.data.msg || this.$t("uploadFailed")));
            }
          })
          .catch((error) => {
            console.error("上传文件出错:", error);
            this.$message.error(this.$t("uploadErrorPleaseRetry"));
            reject(error);
          });
      });
    },
    submitForm() {
      this.submitting = true;
      // 提取fileList中所有文件的url，组成纯URL数组
      const imageUrls = this.fileList.map((file) => file.url || "");
      const submitData = {
        travel_id: this.orderInfo.travel_id, // 游记ID
        travel_plan_id: this.orderInfo.travel_plan_id, // 游记计划ID
        order_no: this.orderNo, // 订单号
        user_id: this.userId, // 用户ID
        rating: this.reviewForm.rating, // 评分（1-5）
        content: this.reviewForm.content, // 评价内容
        images: imageUrls, // 图片URL列表
      };
      // 调用后端提交接口
      this.$post("/review/submit_review", submitData)
        .then((res) => {
          this.submitting = false; // 关闭加载状态
          if (res.data.code === 1) {
            this.successDialogVisible = true; // 显示提交成功弹窗
          } else {
            this.$message.error(res.data.msg || this.$t("reviewSubmitFailed"));
          }
        })
        .catch((error) => {
          this.submitting = false;
          this.$message.error(this.$t("networkErrorReviewSubmitFailed"));
          console.error("评价提交错误：", error);
        });
    },
  },
};
</script>

<style scoped>
.travel-review-page {
  min-height: 100vh;
  background-color: #f5f7fa;
}
/* 头部样式 */
.page-header {
  display: flex;
  align-items: center;
  /* padding: 0 16px; */
  height: 48px;
  background-color: #fff;
  border-bottom: 1px solid #e8e8e8;
}
.back-btn {
  cursor: pointer;
  padding: 8px;
  font-size: 18px;
  color: #333;
}
.page-title {
  flex: 1;
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  color: #333;
}
/* 主内容区 */
.main-content {
  padding: 16px;
}
/* 订单信息卡片 */
.order-info-card {
  margin-bottom: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}
.order-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}
.order-title {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #333;
}
.order-status {
  padding: 2px 8px;
  font-size: 12px;
  color: #4caf50;
  background-color: #f0f9e8;
  border-radius: 4px;
}
.order-details {
  border-top: 1px dashed #e8e8e8;
  padding-top: 12px;
}
.detail-item {
  display: flex;
  margin-bottom: 8px;
  font-size: 14px;
}
.detail-label {
  flex: 0 0 80px;
  color: #999;
}
.detail-value {
  flex: 1;
  color: #333;
}
/* 评价表单卡片 */
.review-form-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}
.form-title {
  margin: 0 0 16px;
  font-size: 16px;
  font-weight: 500;
  color: #333;
}
.review-form {
  width: 100%;
  padding: 10px 0px;
}
.form-item {
  margin-bottom: 16px;
}
/* 星级评分 */
.rating-component {
  font-size: 24px;
  transition: all 0.3s ease;
}
.rating-text {
  margin-left: 12px;
  font-size: 14px;
  color: #ff9900;
}
/* 评价文本框 */
.review-textarea {
  width: 100%;
  transition: border-color 0.3s ease;
}
.review-textarea:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}
.word-count {
  text-align: right;
  margin-top: 4px;
  font-size: 12px;
  color: #999;
}
/* 图片上传 */
.image-uploader {
  margin-bottom: 8px;
}
.upload-tip {
  margin: 0;
  font-size: 12px;
  color: #999;
}
/* 提交按钮 */
.submit-btn-container {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}
.submit-btn {
  width: 100%;
  max-width: 300px;
  height: 44px;
  font-size: 16px;
  transition: all 0.3s ease;
}
.submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}
/* 成功提示 */
.success-message {
  text-align: center;
  padding: 20px 0;
}
.success-icon {
  font-size: 48px;
  color: #4caf50;
  margin-bottom: 16px;
  animation: bounce 1s;
}
@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-20px);
  }
  60% {
    transform: translateY(-10px);
  }
}
/* 响应式设计 */
@media (max-width: 768px) {
  .main-content {
    padding: 12px;
  }
  .order-title {
    font-size: 15px;
  }
  .detail-item {
    flex-wrap: wrap;
  }
  .detail-label {
    flex: 0 0 70px;
  }
  .rating-component {
    font-size: 22px;
  }
  .submit-btn {
    width: 100%;
  }
}
</style>
